import axios from 'axios';
import API_URL from '@/constants/API_URL';

// TODO: Adicionar variáveis da api
const passwordService = {
  recovery(username, cpf) {
    return axios.post(`${API_URL()}/user/password`, { user: { username, cpf } });
  },
  update(password, token) {
    return axios.patch(`${API_URL()}/user/password`, {
      user: {
        password,
        reset_password_token: token,
      },
    });
  },
  // TODO: add api endpoint in the future
  getSmsCode() {
    return '123456';
  },
};

export default passwordService;



// WEBPACK FOOTER //
// ./src/services/PasswordService.js